<script>
import changelog from "../../CHANGELOG.md"

export default {
    extends: changelog.vue.component
}
</script>
